export const SpaceMultiple = 8

export type SpacerMultiplier = 1 | 2 | 3 | 4 | 5 | 7 | 10 | 13 | 18

export const spaceMultiplier = (
  prefix: string,
  Top: number,
  Right: number,
  Bottom: number,
  Left: number,
) =>
  Object.fromEntries(
    Object.entries({
      Top,
      Right,
      Bottom,
      Left,
    }).map(([direction, space]) => [`${prefix}${direction}`, `${space * SpaceMultiple}px`]),
  )

interface FixedSpacerProps {
  multiplier: SpacerMultiplier
}

export const FixedSpacer = (props: FixedSpacerProps) => (
  <div style={{ height: `${props.multiplier * SpaceMultiple}px`, flexShrink: 0 }} />
)
